import { helpers } from '@vuelidate/validators';

export function matchTo<T>(cb: (siblings: T) => unknown) {
  return helpers.withMessage(
    'Does not equal to',
    (value: string | number, siblings, vm) => {
      return value === cb(siblings as T);
    },
  );
}
